import { FireStoreTimestamp } from "../model/model";

export const klassi = (
  obj: Record<string, boolean>,
  klass?: string
): string => {
  return Object.keys(obj)
    .map((key) => (obj[key] ? key : undefined))
    .filter((str) => !!str)
    .concat(klass || "")
    .join(" ")
    .trim();
};

export const mapToList = (map?: Record<string, any>) => {
  if (!map) return [];
  return Object.keys(map || {}).map((key) => {
    const obj = map[key];
    return {
      ...obj,
      key: key,
    };
  });
};

export const storeDate = (timestamp: FireStoreTimestamp): Date | undefined => {
  if (timestamp) {
    return new Date(timestamp.seconds * 1000);
  }
  return undefined;
};

export function isInIframe() {
  try {
    // If this throws, you’re in an iframe on a different origin
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}
